import React from "react";
import { useEffect } from "react";
import ScrollHandler from "../Assets/ScrollHandler";
import bottomAnimate from "../Assets/bottomAnimate";
import Particles from "react-particles-js";
import Navbar from "./Navbar";
import { Grid } from "@material-ui/core";
import HomeItems from "../Assets/HomeItems";
import ContactIcon from "../Assets/ContactIcon";
import { items } from "../../Data/Contacts";

export default () => {
  useEffect(() => {
    window.addEventListener("scroll", ScrollHandler);
    window.addEventListener("load", bottomAnimate);
  }, []);

  return (
    <div id="home">
      <Navbar />
      <Particles
        className="hundred"
        style={{ backgroundColor: "#264653" }}
        params={{
          particles: {
            number: {
              value: 150,
              density: {
                enable: true,
                value_area: 3000,
              },
            },
          },
        }}
      />
      <Grid container>
        <Grid item md={1} />
        <Grid item md={10} xs={12}>
          <HomeItems />
        </Grid>
        <Grid item md={1} />
      </Grid>
      <div className="contact-bar">
        {items.map((e) => (
          <ContactIcon item={e} key={e.id} />
        ))}
      </div>
    </div>
  );
};
